var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVelo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DB2264",
    d: "M12.54 18c-.67-.016-1.26-.238-1.739-.716c-1.771-1.784-3.559-3.552-5.346-5.336c-1.324-1.322-.798-3.551.99-4.109c.94-.286 1.803-.08 2.505.622c1.772 1.751 3.511 3.503 5.267 5.255c.478.478.75 1.051.781 1.736c.048 1.13-.766 2.198-1.883 2.453c-.176.047-.383.063-.575.095m4.404-10.285a2.333 2.333 0 0 1 2.342 2.341a2.36 2.36 0 0 1-2.342 2.373c-1.293.015-2.357-1.065-2.372-2.357a2.37 2.37 0 0 1 2.372-2.357"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVelo);
export default __webpack_public_path__ + "static/media/velo.09e674005cb7d3982986c1fa7df9dc33.svg";
export { ForwardRef as ReactComponent };